import { Box, Avatar, Typography, Tooltip } from "@mui/material";

type Props = {
  email: string | null;
  displayName?: string | null;
};

function getInitials(name: string) {
  const parts = name.split(" ").filter(Boolean);

  if (parts.length === 1) {
    return parts[0].slice(0, 2).toUpperCase();
  }

  return (parts[0][0] + parts[1][0]).toUpperCase();
}

export default function AssignedUserChip({ email, displayName }: Props) {
  if (!email) {
    return (
      <Box
        sx={{
          height: "100%",
          display: "flex",
          alignItems: "center",
        }}
      >
        <Typography
          variant="body2"
          sx={{
            color: "text.disabled",
            fontStyle: "italic",
          }}
        >
          —
        </Typography>
      </Box>
    );
  }

  const name = displayName || email;
  const initials = getInitials(name);

  return (
    <Tooltip title={email}>
      <Box
        sx={{
          height: "100%",
          width: "100%",
          display: "flex",
          alignItems: "center",
          gap: 1,
          minWidth: 0, // 🔥 KLUCZ DO ELLIPSIS
        }}
      >
        <Avatar
          sx={{
            width: 26,
            height: 26,
            fontSize: 11,
            fontWeight: 600,
            bgcolor: "grey.300",
            color: "text.primary",
            flexShrink: 0, // 🔥 NIE ŚCISKAJ AVATARA
          }}
        >
          {initials}
        </Avatar>

        <Typography
          variant="body2"
          sx={{
            fontWeight: 500,
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
            minWidth: 0,
          }}
        >
          {name}
        </Typography>
      </Box>
    </Tooltip>
  );
}
